import React, { useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import ModalAddCoupon from "screens/ModalAddCoupon";
import Slider from "./Slider";
import { useQuery } from "@apollo/client";
import { GET_ALL_COUPONS } from "graphql/service";
import { Content, CouponTableContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";
import { RemoveIcon, EditIcon } from "assets/icons";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";

const CouponCode = () => {
  const [coupons, setCoupons] = useState([]);

  const { data: couponsData, loading, error } = useQuery(
    GET_ALL_COUPONS,
    {
      onCompleted: (couponsData) => {
        setCoupons(couponsData.coupons);
      },
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message;
          if (error.message.includes("Validation")) {
            content = JSON.stringify(
              error.graphQLErrors[0]?.extensions?.exception
            );
          }
          debouncedErrorMessage(content);
        }
      },
    }
  );

  const couponArray = coupons.map((coupon, index) => {
    return (
      <tr key={index}>
        <td className="couponCode">{coupon.title}</td>
        <td className="discount">
          {coupon.rateType === "PERCENTAGE_RATE"
            ? coupon.discount + "%"
            : "$" + coupon.discount}
        </td>
        <td className="startDate">{moment(coupon.validFrom).tz(TIME_ZONE).format("MM/DD/YYYY")}</td>
        <td className="endDate">{moment(coupon.validTo).tz(TIME_ZONE).format("MM/DD/YYYY")}</td>
        <td className="onOff">
          <div className="slider">
            <Slider
              couponId={coupon.couponId}
              checked={coupon.isActive}
              setCoupons={setCoupons}
            />
          </div>
        </td>
        <td className="action">
          <div className="actions">
            <span className="edit">
              <EditIcon /> Edit
            </span>
            <span className="delete">
              <RemoveIcon /> Remove
            </span>
          </div>
        </td>
      </tr>
    );
  });

  return (
    <Card 
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="type">CURRENT COUPON CODES</div>
        <div className="buttonContainer">
          <ModalAddCoupon
            buttonStyle={`
              width: 134px;
            `}
            setCoupons={setCoupons}
          />
        </div>
      </CardHeader>
      <Content>
        {couponArray.length === 0 ? (
          <div className="noCoupon">
            There are no coupon code available. Please use 'Add Coupon Code' to create one.
          </div>
        ) : (
          <>
            <div className="couponDescription">
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. culpa qui officia
              deserunt mollierunt mollie.”
            </div>
            <CouponTableContainer>
              <thead>
                <tr>
                  <th className="couponCode">COUPON CODE</th>
                  <th className="discount">DISCOUNT</th>
                  <th className="startDate">START DATE</th>
                  <th className="endDate">END DATE</th>
                  <th className="onOff">ON/OFF</th>
                  <th className="action">ACTION</th>
                </tr>
              </thead>
              <tbody>{couponArray}</tbody>
            </CouponTableContainer>
          </>
        )}
      </Content>
    </Card>
  );
};

export default CouponCode;
